import { combineReducers } from 'redux';
import merchants from './merchants';
import gspSuggestions from './gspSuggestions';

export default combineReducers({
  merchants,
  gspSuggestions,
});
